export interface UnifiedToolArgs {
  skill?: string;
  params?: Record<string, unknown>;
  [key: string]: unknown;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/**
 * 兼容两种统一工具调用形态：
 * 1. { skill, params: {...} }
 * 2. { skill, foo, bar }  // 某些客户端无法稳定传嵌套 params
 */
export function resolveUnifiedToolParams(args: unknown): Record<string, unknown> {
  if (!isRecord(args)) {
    return {};
  }

  const nestedParams = args.params;
  if (isRecord(nestedParams)) {
    return { ...nestedParams };
  }

  const flatParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(args)) {
    if (key === 'skill' || key === 'params') {
      continue;
    }
    flatParams[key] = value;
  }

  return flatParams;
}